import Axios from "axios";
import { BASE_URL } from "static/constants";
import getToken from "utils/getToken";
import { handleUnauthorizedError } from "utils/auth";

const api = Axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

//add token to all request
api.interceptors.request.use(function (config) {
  const token = getToken();

  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }

  return config;
});

api.interceptors.response.use(
  function (response) {
    if (response.data instanceof Blob) {
      return response;
    }
    return response.data;
  },
  async function (error) {
    const unauthorizedResult = handleUnauthorizedError(
      error.response?.status,
      error.config?.url,
      error.response?.data
    );
    if (unauthorizedResult) {
      return unauthorizedResult;
    }

    let errorString = error?.response?.data;

    if (
      error.request.responseType === "blob" &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf("json") !== -1
    ) {
      errorString = JSON.parse(await error.response.data.text());

      return Promise.reject({
        ...errorString,
        httpStatus: error.response.status,
      });
    } else if (error.response && error.response.data) {
      const { data, status, statusText } = error.response;
      if (typeof data === "object" && !Array.isArray(data)) {
        return Promise.reject({ ...data, httpStatus: status });
      }
      return Promise.reject({ message: statusText, httpStatus: status });
    } else {
      return Promise.reject({
        message: error?.response?.statusText,
        httpStatus: error?.response?.status,
      });
    }
  }
);

export default api;
